export default __webpack_public_path__ + "static/media/jower-bajra-icon.5e5121ed.svg";